import * as React from 'react';
import { cn } from '../../../../../utils/tailwind';

export interface TableCellThPropsInterface {
    children?: React.ReactNode;
    align?: 'left' | 'center' | 'right';
    width?: number | string;
    sticky?: 'left' | 'right';
    isScrolled?: boolean;
    isScrollable?: boolean;
    isScrollOnEnd?: boolean;
    locked?: boolean;
    leftGap?: boolean;
    colSpan?: number;
}

export const TableCellTh: React.FC<TableCellThPropsInterface> = ({
    children,
    align = 'left',
    sticky,
    width,
    isScrolled,
    isScrollable,
    isScrollOnEnd,
    locked,
    leftGap = true,
    colSpan,
}: TableCellThPropsInterface) => {
    const widthValue = typeof width === 'number' ? `${width}rem` : width;
    const contentClassName = cn(
        'flex w-full justify-start text-left',
        align === 'center' && 'flex justify-center text-center',
        align === 'right' && 'flex justify-end text-right',
    );

    return (
        <th
            colSpan={colSpan}
            className={cn(
                'relative border-0 px-small py-small text-vsmall uppercase leading-vsmall text-text-muted',
                !leftGap && 'pl-0',
                align === 'center' && 'text-center',
                align === 'right' && 'text-right',
                locked && 'select-none blur-[0.3rem]',
                sticky === 'left' && 'sticky left-0 z-[100] bg-body',
                sticky === 'right' && 'sticky right-0 z-[100] bg-body',
                isScrolled &&
                    sticky === 'left' &&
                    'after:pointer-events-none after:absolute after:bottom-[-1px] after:right-0 after:top-0 after:w-[3rem] after:translate-x-full after:shadow-[inset_10px_0_8px_-8px_rgba(0,0,0,0.3)] after:content-[""]',
                (isScrolled || isScrollable) &&
                    sticky === 'right' &&
                    'before:pointer-events-none before:absolute before:bottom-[-1px] before:left-[-6rem] before:top-0 before:w-[3rem] before:translate-x-full before:shadow-[inset_-10px_0_8px_-8px_rgba(0,0,0,0.3)] before:content-[""]',
                isScrollOnEnd && sticky === 'right' && 'before:hidden',
            )}
            style={widthValue ? ({ width: widthValue, minWidth: widthValue } as React.CSSProperties) : undefined}
        >
            <div className={contentClassName}>{children}</div>
        </th>
    );
};
